module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia-gz.cc56dfe8.png";